import FreshchatScriptWrapper from './FreshchatScriptWrapper';

export default FreshchatScriptWrapper;
